import React from 'react'
import Section from '../../components/Section'

export default function OverlayPreview({ heading, subheading, modules, ...rest }: ZionCMSOverlay): JSX.Element {
  if (!heading && !subheading && !modules) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>
  }

  if (heading) {
    const headerBlock = {
      modelType: 'HeaderBlock',
      heading,
      subheading,
    }
    const newModules = [headerBlock, ...(modules ?? [])]
    return <Section modules={newModules} {...rest} />
  }

  return <Section modules={modules} {...rest} />
}
